<div class="ui-grid ui-grid-responsive ui-fluid">
  <div>
    <div>
      <company-search-grid [gridComponent]="gridComponent" [customerImportEndpoint]="customerImportEndpoint" ></company-search-grid>
    </div>
  </div>
</div>
